import { render, staticRenderFns } from "./TemperatureHumidityChart.vue?vue&type=template&id=4504139c&scoped=true"
import script from "./TemperatureHumidityChart.vue?vue&type=script&lang=js"
export * from "./TemperatureHumidityChart.vue?vue&type=script&lang=js"
import style0 from "./TemperatureHumidityChart.vue?vue&type=style&index=0&id=4504139c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4504139c",
  null
  
)

export default component.exports